import axios from 'axios'
import { CHAT_BOT_URL } from '../../env/env'

export const getAllThreads = async () => {
  const response = await axios.get(`${CHAT_BOT_URL}threads`)
  return response
}

export const getThreadMessages = async (threadId) => {
  const response = await axios.get(
    `${CHAT_BOT_URL}threads/${threadId}/messages`
  )
  return response
}

export const sendThreadMessage = async (payload) => {
  const response = await axios.post(`${CHAT_BOT_URL}chat`, payload)
  return response
}

export const stopThreadMessage = async (payload) => {
  const response = await axios.post(`${CHAT_BOT_URL}chat/stop`, payload)
  return response
}

export const getThreadMessageStatus = async (messageId) => {
  const response = await axios.get(`${CHAT_BOT_URL}chat/status/${messageId}`)
  return response
}

export const sendThreadMessageResume = async (payload) => {
  const response = await axios.post(`${CHAT_BOT_URL}chat/resume`, payload)
  return response
}

export const getContestAssessmentList = async () => {
  const response = await axios.get(`ai-chats/assessment-list`)
  return response
}

export const getCandidateAssessments = async (candidateId, actionType) => {
  const response = await axios.get(
    `ai-chats/candidate-assessments?candidateId=${candidateId}&action=${actionType}`
  )
  return response
}

export const getSlashCommands = async () => {
  const response = await axios.get(`${CHAT_BOT_URL}chat/command-list`)
  return response
}
